import React, { useState, useRef } from "react";
import { observer } from "mobx-react";
import FilterDropdown from "./FilterDropdown";

const UpdateStage = observer(props => {
  const {
    setActiveDropdownIndex = () => {},
    change = () => {},
    defaultValue = "",
    contactStageList = []
  } = props || {};
  const selectBoxRef = useRef(null);
  const [selectedItem, setSelectedItem] = useState({});

  const filterCbk = item => {
    change("tagValue", item);
    setSelectedItem(item);
    setActiveDropdownIndex(null);
  };

  return (
    <div className="selectedTagWrapper">
      <FilterDropdown
        options={contactStageList}
        isCustomValue={true}
        customCbk={filterCbk}
        refValue={selectBoxRef}
        hasValue={true}
        {...props}
        defaultValue={selectedItem?.value ? selectedItem?.value : defaultValue}
        emptyText="There are no contact stages"
        animationClass="customDropDownFadeIn"
      />
    </div>
  );
});

export { UpdateStage };
export default UpdateStage;
